import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchAttachments = createAction(constants.FETCH_ATTACHMENTS)
export const fetchAttachmentsPending = createAction(constants.FETCH_ATTACHMENTS_PENDING)
export const fetchAttachmentsFailed = createAction(constants.FETCH_ATTACHMENTS_FAILED)
export const fetchAttachmentsCancelled = createAction(constants.FETCH_ATTACHMENTS_CANCELLED)
export const receiveAttachments = createAction(constants.RECEIVE_ATTACHMENTS)

export const uploadAttachment = createAction(constants.UPLOAD_ATTACHMENT)
export const uploadAttachmentPending = createAction(constants.UPLOAD_ATTACHMENT_PENDING)
export const uploadAttachmentFailed = createAction(constants.UPLOAD_ATTACHMENT_FAILED)
export const uploadAttachmentSuccess = createAction(constants.UPLOAD_ATTACHMENT_SUCCESS)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/message/attachment/actions.js